import { render, staticRenderFns } from "./ArticleViewer.vue?vue&type=template&id=6f9c0102&scoped=true&"
import script from "./ArticleViewer.vue?vue&type=script&lang=js&"
export * from "./ArticleViewer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleViewer.vue?vue&type=style&index=0&id=6f9c0102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c0102",
  null
  
)

export default component.exports